import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import { toJS } from 'mobx';
import _ from 'lodash';

import Spinner from '../Spinner';
import ObservationsTable from './_commons/ObservationsTable';
import ObservationTaskBar from "./_commons/ObservationTaskBar";
import SelectedObservationQcTable from "./_commons/SelectedObservationQcTable";

import GraphView from "../GraphView";
import { getDisplayDate } from "../../libs/date";

@inject('hqcStore', 'stationStore', 'qcFlagStore')
@observer
export default class Graph extends React.Component {
    @observable chart = null;

    dispose;

    componentDidMount() {
        this.props.qcFlagStore.fetchItems();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { getNewlyAddedObservations, setObservations, setData } = this.props.hqcStore;

        if (nextProps.hqcStore.selectedDataSeries.length > 0) {
            if (toJS(this.props.hqcStore.selectedDataSeries) !== toJS(nextProps.hqcStore.selectedDataSeries) || !_.isEqual(toJS(this.props.hqcStore.selectedDataSeries), toJS(nextProps.hqcStore.selectedDataSeries))) {
                console.log("getObservation Call")

                getNewlyAddedObservations();
            }
        } else {
            setData([]);
            setObservations([]);
        }
    }

    @action
    componentWillUnmount() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }

        if (this.dispose)
            this.dispose();
    }

    getQcFlagEntryByFlag = (flag) => {
        return this.props.qcFlagStore.items.find(item => +item.caption === +flag);
    };

    @action clearSelected = () => {
        const { setSelectedObservations } = this.props.hqcStore;
        setSelectedObservations([]);
    }

    handleSelection = (event) => {
        const {
            selectedDataSeries,
            setSelectedObservations,
            observations,
        } = this.props.hqcStore;

        if (event && event.xAxis && event.xAxis.length === 1) {
            const { xAxis } = event;
            const [xaxis] = xAxis;

            if (observations) {
                const allRelatedObservations = observations.find(item => +item.series_id === +selectedDataSeries[0].id);

                if (allRelatedObservations && allRelatedObservations.arr) {
                    const newSelectedObservations = [...allRelatedObservations.arr.filter(item => new Date(item.time).getTime() < new Date(xaxis.max).getTime() && new Date(item.time).getTime() > new Date(xaxis.min).getTime())];

                    setSelectedObservations(newSelectedObservations);
                }
            }
        } else {
            setSelectedObservations([]);
        }
    }

    render() {
        const { stationStore, hqcStore } = this.props;
        const {
            setData,
            setReferenceMarker,
            setSelectedDataSeries,
            setSelectedObservations,
            date_from,
            date_to,
            handleFromChange,
            handleToChange,
            getObservations,
            isLoading,
            ignore,
            setObservations,
            selectedDataSeries,
            data,
            pinned,
            setPinned,
            selectedObservations,
        } = hqcStore;
        if (isLoading) {
            return <Spinner />;
        }

        let graphOptions = {
            chart: {
                zoomType: 'x',
                events: {
                    selection: this.handleSelection,
                },
            },
            title: {
                style: {
                    display: 'none'
                }
            },
            xAxis: [{
                type: 'datetime',
                dateTimeLabelFormats: { // don't display the dummy year
                    second: '%H:%M:%S',
                },
            }],
            tooltip: {
                shared: true,
                followPointer: true,
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    animation: false
                },
            },
            series: []
        };

        const uniqueYAxes = [];

        selectedDataSeries.forEach(d => {
            if (!d.parameter_unit) return;
            if (!uniqueYAxes.find(axis => axis.name === d.parameter_unit.name && axis.symbol === d.parameter_unit.symbol)) {
                uniqueYAxes.push({
                    name: d.parameter_unit.name,
                    symbol: d.parameter_unit.symbol,
                });
            }
        });

        selectedDataSeries.filter(i => !ignore.find(ig => +ig === +i.id)).forEach(item => {
            const selectedStation = stationStore.findById(item.station_id);
            const observations = hqcStore.observations.find(o => +o.series_id === +item.id);
            if (observations && observations.arr && observations.arr.length > 0) {
                graphOptions.series.push({
                    yAxis: uniqueYAxes.findIndex(axis => axis.name === item.parameter_unit.name && axis.symbol === item.parameter_unit.symbol),
                    turboThreshold: 0,
                    type: item.property === 'Accumulative' ? 'column' : 'line',
                    name: `[${selectedStation.name}] ${item.parameter.code}${item.parameter_unit ? `${item.parameter_unit.symbol ? ` (${item.parameter_unit.symbol})` : ''}` : ''}`,
                    data: observations.arr.sort((a, b) => {
                        return new Date(a.time).getTime() - new Date(b.time).getTime();
                    }).map(observation => [
                        getDisplayDate(observation.time, { returnMills: true }),
                        parseFloat(observation.value)
                    ])
                });
            }
        });

        graphOptions.yAxis = uniqueYAxes.map((axis, index) => ({
            labels: {
                format: `{value}${axis.symbol}`,
            },
            title: {
                text: axis.name,
            },
            opposite: !!index,
        }));

        return <div>
            <ObservationTaskBar slug={'analysis/hqc/graph'}
                reset={(e) => {
                    e.preventDefault();

                    setObservations([]);
                    setData([]);
                    setSelectedDataSeries([]);
                    setReferenceMarker(null);
                    setSelectedObservations([]);
                }} date_from={date_from}
                date_to={date_to}
                handleFromChange={handleFromChange}
                handleToChange={handleToChange}
                getObservations={getObservations} />
            <div style={{ position: 'relative' }}>
                <div style={pinned ? { position: 'sticky', top: 0 } : {}}>
                    <div style={{ flex: 1, width: '100%', position: 'relative' }}>
                        <i style={{ position: 'absolute', top: 0, right: 0, zIndex: 99999 }}
                            className={`fa fa-thumb-tack ${pinned ? 'pin-active' : 'pin'}`}
                            onClick={() => setPinned(!pinned)} />
                        <GraphView options={graphOptions} />
                    </div>
                </div>
                {
                    data.length > 0 ?
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div style={{ marginTop: '20px', flex: 3, display: 'flex', alignItems: 'baseline' }}>
                                <ObservationsTable spaceForPin={true} getQcFlagEntryByFlag={this.getQcFlagEntryByFlag} />
                                {selectedObservations.length > 0 && <button className='button' onClick={this.clearSelected}>Clear selected</button>}

                            </div>
                            <div style={{ flex: 1 }}>
                                <SelectedObservationQcTable spaceForPin={true}
                                    flags={this.props.qcFlagStore.items}
                                    getQcFlagEntryByFlag={this.getQcFlagEntryByFlag} />
                            </div>
                        </div> :
                        <div style={{ textAlign: 'center' }}>
                            <span>No observations found!</span>
                        </div>
                }
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/HQC/Graph.js